// Loại phiếu lương (enum cố định)
export const slipTypeOptions = [
	{ value: 'advance',    label: 'Ứng lương' },
	{ value: 'insurance',  label: 'Bảo hiểm' },
	{ value: 'allowance',  label: 'Trợ cấp' },
	{ value: 'bonus',      label: 'Thưởng' },
	{ value: 'adjustment', label: 'Điều chỉnh lương' },
];

export const slipTypeLabels = {
	advance    : 'Ứng lương',
	insurance  : 'Bảo hiểm',
	allowance  : 'Trợ cấp',
	bonus      : 'Thưởng',
	adjustment : 'Điều chỉnh lương',
};

// Loại tính
export const calcTypeOptions = [
	{ value: 'minus', label: 'Trừ lương' },
	{ value: 'plus',  label: 'Cộng lương' },
];

export const calcTypeLabels = {
	minus : 'Trừ lương',
	plus  : 'Cộng lương',
};

export const calcTypeColors = {
	minus : 'red',
	plus  : 'green',
};

// Đối tượng
export const objectOptions = [
	{ value: 'employee', label: 'Nhân viên' },
	{ value: 'company',  label: 'Công ty' },
];

export const objectLabels = {
	employee : 'Nhân viên',
	company  : 'Công ty',
};

// Loại tính mặc định theo loại phiếu (adjustment để user tự chọn)
export const defaultCalcBySlipType = {
	advance   : 'minus',
	insurance : 'minus',
	allowance : 'plus',
	bonus     : 'plus',
};
